import { useAppStore } from '../../../store/appStore';
import {
  ALL_DELIVERY_COMPLETED_BACKGROUND_URL,
  ALL_DELIVERY_COMPLETED_BODY_TEXT_URL,
  ALL_DELIVERY_COMPLETED_TITLE_TEXT_URL,
} from './allDeliveryCompletedAssets';
import {
  ALL_DELIVERY_COMPLETED_BODY_ALT,
  ALL_DELIVERY_COMPLETED_LAYOUT,
  ALL_DELIVERY_COMPLETED_SIZE,
  ALL_DELIVERY_COMPLETED_TITLE_ALT,
} from './allDeliveryCompletedLayout';
import { useMoscowCountdown } from '../../../hooks/useMoscowCountdown';
import './AllDeliveryCompletedModal.css';

/** Figma all_delivery_completed (185:9197) — blocks map pan/clicks; HUD stays above. */
export function AllDeliveryCompletedModal() {
  const { titleText, bodyText, countdown } = ALL_DELIVERY_COMPLETED_LAYOUT;
  const refreshEconomy = useAppStore((s) => s.refreshEconomy);
  const countdownLabel = useMoscowCountdown(() => {
    void refreshEconomy();
  });

  return (
    <div
      className="all-delivery-completed-modal"
      role="dialog"
      aria-modal="true"
      aria-label={ALL_DELIVERY_COMPLETED_TITLE_ALT}
    >
      <div className="all-delivery-completed-modal__backdrop" aria-hidden />
      <div
        className="all-delivery-completed-modal__frame"
        style={{
          width: ALL_DELIVERY_COMPLETED_SIZE.width,
          height: ALL_DELIVERY_COMPLETED_SIZE.height,
        }}
      >
        <img
          className="all-delivery-completed-modal__background"
          src={ALL_DELIVERY_COMPLETED_BACKGROUND_URL}
          alt=""
          draggable={false}
          aria-hidden
        />
        <img
          className="all-delivery-completed-modal__title"
          src={ALL_DELIVERY_COMPLETED_TITLE_TEXT_URL}
          alt={ALL_DELIVERY_COMPLETED_TITLE_ALT}
          draggable={false}
          style={{
            left: titleText.left,
            top: titleText.top,
            width: titleText.width,
            height: titleText.height,
          }}
        />
        <p
          className="all-delivery-completed-modal__countdown"
          aria-live="polite"
          style={{
            left: countdown.left,
            top: countdown.top,
            width: countdown.width,
            height: countdown.height,
          }}
        >
          {countdownLabel}
        </p>
        <img
          className="all-delivery-completed-modal__body"
          src={ALL_DELIVERY_COMPLETED_BODY_TEXT_URL}
          alt={ALL_DELIVERY_COMPLETED_BODY_ALT}
          draggable={false}
          style={{
            left: bodyText.left,
            top: bodyText.top,
            width: bodyText.width,
            height: bodyText.height,
          }}
        />
      </div>
    </div>
  );
}
